import React from "react";
import featureBg from "../../images/bg/features-gradient-bg.png";
import feaIcon01 from "../../images/icon/fea-small-icon01.svg";
import feaIcon02 from "../../images/icon/fea-small-icon02.svg";
import feaIcon03 from "../../images/icon/fea-small-icon03.svg";
import feaIcon04 from "../../images/icon/fea-small-icon04.svg";
import aeris from "../../images/hero/aeris.png";


const FeaturesAndBrands: React.FC = () => {
  return (
    <div
      className="bg_img"
      style={{
        background: `url(${featureBg}) no-repeat center center`,
        backgroundSize: "cover",
      }}
    >
      {/* Feature Section */}
      <section className="feature pt-145">
        <div className="container">
          <div className="sec-title sec-title-center fea-sec-title text-center mb-50">
            <span className="sub-title">Our Strategic Pillars</span>
            <h2 className="title">Four pillars, one mission</h2>
          </div>

          <div className="row mt-none-30 align-items-center">
            {/* Left Features — Corporate Statutes, Chapter 8 (Pillars 1–2) */}
            <div className="col-lg-4 col-md-6 mt-30">
              <div className="xb-feature-left-item">
                <div
                  className="xb-feature-item xb-feature-item2 wow fadeInUp"
                  data-wow-delay="100ms"
                  data-wow-duration="600ms"
                >
                  <div className="xb-item--inner justify-content-end xb-border">
                    <h2 className="xb-item--title text-end">
                      Innovation <br /> creating new value
                    </h2>
                    <span className="xb-item--icon">
                      <img src={feaIcon01} alt="icon" />
                    </span>
                  </div>
                </div>

                <div
                  className="xb-feature-item xb-feature-item2 wow fadeInUp"
                  data-wow-delay="200ms"
                  data-wow-duration="600ms"
                >
                  <div className="xb-item--inner justify-content-end xb-border">
                    <h2 className="xb-item--title text-end">
                      Transformation of <br /> industries & institutions
                    </h2>
                    <span className="xb-item--icon">
                      <img src={feaIcon02} alt="icon" />
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Features — Corporate Statutes, Chapter 8 (Pillars 3–4) */}
            <div className="col-lg-4 col-md-6 order-lg-last mt-30">
              <div className="xb-feature-right-item">
                <div
                  className="xb-feature-item xb-feature-item2 xb-border wow fadeInUp"
                  data-wow-delay="100ms"
                  data-wow-duration="600ms"
                >
                  <div className="xb-item--inner xb-border">
                    <span className="xb-item--icon">
                      <img src={feaIcon03} alt="icon" />
                    </span>
                    <h2 className="xb-item--title">
                      Capability & <br /> future-ready talent
                    </h2>
                  </div>
                </div>

                <div
                  className="xb-feature-item xb-feature-item2 xb-border wow fadeInUp"
                  data-wow-delay="200ms"
                  data-wow-duration="600ms"
                >
                  <div className="xb-item--inner xb-border">
                    <span className="xb-item--icon">
                      <img src={feaIcon04} alt="icon" />
                    </span>
                    <h2 className="xb-item--title">
                      Impact that is <br /> measurable & lasting
                    </h2>
                  </div>
                </div>
              </div>
            </div>

            {/* Center — Aeris (animated) */}
            <div className="col-lg-4 col-md-12 mt-30">
              <div
                className="xb-feature-img pos-rel text-center wow zoomIn"
                data-wow-delay="0ms"
                data-wow-duration="600ms"
              >
                <div className="xb-feature-aeris">
                  <img src={aeris} alt="Aeris — KOT" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FeaturesAndBrands;
